import type { ChipProps } from "@mui/material";
import type { DocumentType, Role } from "@/types/api/types.ts";

export const ROLE_USER: Role = "ROLE_USER";
export const ROLE_ADMIN: Role = "ROLE_ADMIN";
export const ROLE_SUPER_ADMIN: Role = "ROLE_SUPER_ADMIN";

export const ROLE_DISPLAY_LABEL = Object.freeze({
  ROLE_USER: "Utilisateur",
  ROLE_ADMIN: "Administrateur",
  ROLE_SUPER_ADMIN: "Super Administrateur",
});

export const DOCUMENT_TYPE_LABELS: Record<DocumentType, string> = {
  global_results: "Résultats globaux",
  individual_results: "Résultat individuel",
  certificate: "Certificat",
  other: "Autre",
};

export const DOCUMENT_TYPE_LABORATORY_LABELS: Partial<Record<DocumentType, string>> = {
  individual_results: "Résultat laboratoire",
};

export const DOCUMENT_TYPE_COLORS: Record<DocumentType, ChipProps["color"]> = {
  global_results: "primary",
  individual_results: "success",
  certificate: "warning",
  other: "default",
};
